<template>
  <c-modal
    v-model="modal"
    :title="'Add New Item'"
    size="xl"
    confirm-label="Save"
    cancel-label="Cancel"
    :progressing="progressing"
    @submit="submit"
    @show="showModal"
    :tag="false"
    centered
  >
    <template #activator>
      <span @click="modal = true" class="cursor-pointer text-white small p-1" style="border-radius: 3px; background: red">
    Add Item
        <font-awesome-icon icon="plus" class="align-middle small" />
      </span>
    </template>
    <template>
      <b-container fluid class="px-0">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group>
              <b-input-group :prepend="edibleType === 'Food' ? 'Food Name' : 'Drink Name'">
                <b-input
                  class="myFeild"
                  :name="edibleType === 'Food' ? 'Food Name' : 'Drink Name'"
                  v-model="model.Name"
                  placeholder="Required"
                  v-validate="'required'"
                />
              </b-input-group>
              <b-input-group v-if="menuboardAllowed" prepend="ReferenceID" class="mt-2">
                <b-input
                  class="myFeild "
                  :name="edibleType === 'Food' ? 'Food Name' : 'Drink Name'"
                  v-model="model.ReferenceID"
                  placeholder="Optional"
                  
                />
              </b-input-group>
            </b-form-group>

            <b-form-group v-if="AllowSecondLang" class="mb-3 mb-md-0">
              <b-input-group prepend="Second Language Name">
                <b-input class="myFeild" placeholder="Optional" v-model="model.Name_SecondLang" name="Second Language Name" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group>
              <b-input-group prepend="Category Name">
                <b-input name="Category Name" v-model="category.CategoryDESC" disabled readonly />
              </b-input-group>
              <b-input-group prepend="Menu Board TV Name" v-if="HasTV" class="mt-2">
                <b-form-select
                  class="myFeild"
                  v-model="selectedTV"
                  :options="TVs"
                  placeholder="Select"
                >
                  <template #first>
                    <b-form-select-option :value="null||''">Select...</b-form-select-option>
                  </template>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="6" lg="3">
                <b-form-checkbox
                  class="my-2"
                  :disabled="model.GlutenFreeRequest"
                  v-model="model.GlutenFree"
                  @input="toggleCheckBox('gluten', model.GlutenFree)"
                  >Gluten Free</b-form-checkbox
                >
              </b-col>
              <b-col cols="6" lg="3">
                <b-form-checkbox
                  class="my-2"
                  @input="toggleCheckBox('glutenR', model.GlutenFreeRequest)"
                  :disabled="model.GlutenFree"
                  v-model="model.GlutenFreeRequest"
                  >Gluten Free Upon Request</b-form-checkbox
                >
              </b-col>
              <b-col v-if="edibleType === 'Drink'" cols="6" lg="3">
                <b-form-checkbox class="my-2" v-model="model.Alcoholic">Alcoholic</b-form-checkbox>
              </b-col>
              <b-col v-if="edibleType === 'Drink' && model.Alcoholic" cols="6" lg="3">
                <b-input-group prepend="ABV (%)">
                  <b-input
                    class="myFeild"
                    name="ABV'"
                    v-model="model.ABV"
                    type="number"
                    placeholder="Optional"
                    v-validate="'min_value: 0'"
                  />
                </b-input-group>
              </b-col>
              <template v-if="edibleType === 'Food'">
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('vegan', model.Vegan)"
                    :disabled="model.VeganRequest"
                    v-model="model.Vegan"
                    >Vegan</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('veganR', model.VeganRequest)"
                    :disabled="model.Vegan"
                    v-model="model.VeganRequest"
                    >Vegan Upon Request</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('vegeterian', model.Vegeterian)"
                    :disabled="model.VegeterianRequest"
                    v-model="model.Vegeterian"
                    >Vegetarian</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('vegeterianR', model.VegeterianRequest)"
                    :disabled="model.Vegeterian"
                    v-model="model.VegeterianRequest"
                    >Vegetarian Upon Request</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('hot', model.Hot)"
                    :disabled="model.HotRequest"
                    v-model="model.Hot"
                    >Hot/Spicy</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('hotR', model.HotRequest)"
                    :disabled="model.Hot"
                    v-model="model.HotRequest"
                    >Hot/Spicy Upon Request</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.Kosher">Kosher</b-form-checkbox>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.Halal">Halal Meat</b-form-checkbox>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.DairyFree">Dairy Free</b-form-checkbox>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.Uncooked">Raw/Undercooked</b-form-checkbox>
                </b-col>
              </template>
            </b-row>
          </b-col>
        </b-row>
        <hr />
        <div v-for="(item, index) in info">
          <food-info
            v-if="index === 0"
            :AllowSecondLang="AllowSecondLang"
            :edibleType="edibleType"
            :number="index + 1"
            :value="item"
          />
        </div>
        <b-collapse v-model="showMore">
          <div v-for="(item, index) in info">
            <food-info
              v-if="index !== 0"
              :edibleType="edibleType"
              :AllowSecondLang="AllowSecondLang"
              :number="index + 1"
              :value="item"
            />
          </div>
        </b-collapse>
        <section class="text-primary text-center cursor-pointer" @click="showMore = !showMore">
          <span v-if="showMore">Show less</span>
          <span v-else>Show more</span>
        </section>
        <hr />
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <b-input-group prepend="Description">
                <b-textarea class="myFeild" placeholder="Optional" v-model="model.Desc" name="Description" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6">
            <b-form-group>
              <b-input-group prepend="Modifier Group" class="d-flex flex-nowrap">
                <Multiselect
                  class="miniMulti"
                  v-model="model.Modifiers"
                  isMultiPle
                  :options="modifiers"
                  name="item"
                  placeHolder="Select Group..."
                />
              </b-input-group>
            </b-form-group>

            <b-form-group v-if="loyaltyPermission">
              <b-input-group prepend="Loyalty Reward" class="d-flex flex-nowrap">
                <Multiselect
                  class="miniMulti"
                  v-model="selectedLoyaltyRewards"
                  isMultiPle
                  :options="loyaltyRewards"
                  name="loyaltyReward"
                  placeHolder="Select Reward..."
                >
                  <template v-slot:tag="{ option, remove }">
                    <span :style="{backgroundColor: option.Status === 'active' ? '#FFC107' : '#c8ced3', borderRadius:'12px', padding:'2px 10px', marginRight:'5px', marginBottom:'5px', display:'inline-flex', alignItems:'center'}">
                      {{ option.name }}
                      <span class="ml-2 cursor-pointer" @mousedown.prevent="remove(option)"><font-awesome-icon icon="times"/></span>
                    </span>
                  </template>
                </Multiselect>
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-input-group prepend="Ingredients *">
                <b-textarea class="myFeild" placeholder="Optional" v-model="model.Ingredients" name="Ingredients" />
              </b-input-group>
            </b-form-group>
            <p class="mb-0 text-danger">
              * Ingredinets are NOT visible to users and are utilized for search purposes only.
            </p>
          </b-col>
          <b-col cols="12">
            <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
              <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{ err }}</li>
              </ul>
            </b-alert>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </c-modal>
</template>

<script>
import { has } from 'lodash';
import CModal from '../../../../shared/Cmodal'
import FoodInfo from './foodInfo'
import Multiselect from '@/components/shared/multiselect'
export default {
  name: 'createFood',
  components: {FoodInfo, CModal, Multiselect},
  props: {
    category: {
      required: true,
      type: Object
    },
    edibleType: {required: true},
    AllowSecondLang: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progressing: false,
        selected: [], // Must be an array reference!
      TVs:[],
      TVrereferences:[],
      selectedTV:"",
      info: [
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''}
      ],
      showMore: false,
      modal: false,
      modifiers: [],
      modifire: null,
      loyaltyPermission: false,
      loyaltyRewards: [],
      loyaltyRewardsFull: [],
      selectedLoyaltyRewards: [],
      initialLoyaltyRewardIds: [],
      model: {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        EdibleType: this.edibleType,
        CategoryID: this.category.CategoryID,
        Name: '',
        GlutenFree: false,
        Vegeterian: false,
        Hot: false,
        GlutenFreeRequest: false,
        HotRequest: false,
        VegeterianRequest: false,
        Kosher: false,
        Halal: false,
        Vegan: false,
        VeganRequest: false,
        Alcoholic: false,
        IsSide: false,
        DairyFree:false,
        Uncooked:false,
        Name_SecondLang: '',
        Ingredients: '',
        Description: '',
        ABV: '',
        IsSide: 0,
        Modifiers: [],
        ReferenceID:'',
      },
      HasTV:localStorage.getItem("hasMenuboard") === "true",
      menuboardAllowed:localStorage.getItem("hasMenuboard")
    }
  },
  
  methods: {
    toggleCheckBox(type, val) {
      if (type === 'gluten' && val) {
        this.model.GlutenFreeRequest = false
      }
      if (type === 'glutenR' && val) {
        this.model.GlutenFree = false
      }
      if (type === 'vegan' && val) {
        this.model.VeganRequest = false
      }
      if (type === 'veganR' && val) {
        this.model.Vegan = false
      }
      if (type === 'vegeterian' && val) {
        this.model.VegeterianRequest = false
      }
      if (type === 'vegeterianR' && val) {
        this.model.Vegeterian = false
      }
      if (type === 'hot' && val) {
        this.model.HotRequest = false
      }
      if (type === 'hotR' && val) {
        this.model.Hot = false
      }
    },
    showModal() {
      const model = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        EdibleType: this.edibleType,
        CategoryID: this.category.CategoryID,
        Name: '',
        GlutenFree: false,
        Vegeterian: false,
        Hot: false,
        GlutenFreeRequest: false,
        HotRequest: false,
        VegeterianRequest: false,
        Kosher: false,
        Halal: false,
        Vegan: false,
        VeganRequest: false,
        Alcoholic: false,
        DairyFree:false,
        Uncooked:false,
        IsSide: false,
        Name_SecondLang: '',
        Ingredients: '',
        Description: '',
        ABV: '',
        IsSide: 0,
        Modifiers: []
      }
      this.selectedLoyaltyRewards = []
      this.initialLoyaltyRewardIds = []
      const info = [
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''}
      ]
      this.info = info
      this.model = model
      this.getModifierGroups()
      this.getRestaurantTVs()
      this.getLoyaltySettings()
    },
    getLoyaltySettings(){
      const model = {RestaurantID: Number(this.$store.state.selectedRestaurantId)}
      return this.$api.loyaltyAdmin.GetSettings(model).then(res => {
        if(res.success){
          this.loyaltyPermission = !!res.results.LoyaltyPermission
          this.loyaltyRewardsFull = res.results.Rewards || []
          this.loyaltyRewards = this.loyaltyRewardsFull.map(item => ({name: item.Name, value: item.RewardID, Status: item.Status}))
          this.initialLoyaltyRewardIds = []
          this.selectedLoyaltyRewards = []
        }
      })
    },
    syncLoyaltyRewards(refId, itemCommodity, finalIds, initialIds) {
      const scopeKind = itemCommodity ? 'item' : 'category'
      const toAdd = finalIds.filter(id => !initialIds.includes(id))
      const toRemove = initialIds.filter(id => !finalIds.includes(id))
      const jobs = [...toAdd.map(id => ({id, add: true})), ...toRemove.map(id => ({id, add: false}))]
      return Promise.all(jobs.map(({id, add}) => {
        const reward = this.loyaltyRewardsFull.find(r => r.RewardID === id)
        if (!reward) return Promise.resolve()
        let scope = Array.isArray(reward.Scope) ? [...reward.Scope] : []
        const matches = s => s.ScopeKind === scopeKind && Number(s.RefID) === Number(refId) && (!itemCommodity || String(s.ItemCommodity).toLowerCase() === String(itemCommodity).toLowerCase())
        if (add) {
          if (!scope.some(matches)) {
            const entry = {ScopeKind: scopeKind, RefID: refId}
            if (itemCommodity) entry.ItemCommodity = itemCommodity
            scope.push(entry)
          }
        } else {
          scope = scope.filter(s => !matches(s))
        }
        return this.$api.loyaltyAdmin.SaveReward({
          RestaurantID: Number(this.$store.state.selectedRestaurantId),
          RewardID: reward.RewardID,
          Name: reward.Name,
          PointsThreshold: reward.PointsThreshold,
          RewardType: reward.RewardType,
          Value: reward.Value,
          Scope: scope
        })
      }))
    },
    getRestaurantTVs(){
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    TVid:-1
                }
                return this.$api.getRestaurant.GetRestaurantMenuboardTVs(object).then(res=>{
                    if(res.success){
                        this.TVs = res.menuBoards.map(tv => tv.TVname)
                        this.TVrereferences = res.menuBoards
                    }
                    
                })

            },
    getModifierGroups() {
      let data = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        CategoryID: -1,
        ModifierType: this.edibleType === 'Food' ? 'Food' : 'Drink'
      }
      return this.$api.getRestaurant.GetRestaurantCategoryModifier(data, true).then(res => {
        if (res.success) {
          this.modifiers = res.results.RestaurantMidifierCategoriesAll
          this.modifiers.forEach(item => {
            item.value = item.ModifierCategoryID
            item.name = item.ModifierCategory
          })
          return res.results
        } else {
        }
      })
    },
    submit() {
      this.$validator.validateAll().then(proceed => {
        const base = {...this.model}
        base.GlutenFree = this.$convertBoolean(base.GlutenFree)
        base.GlutenFreeRequest = this.$convertBoolean(base.GlutenFreeRequest)
        base.Vegeterian = this.$convertBoolean(base.Vegeterian)
        base.VegeterianRequest = this.$convertBoolean(base.VegeterianRequest)
        base.Hot = this.$convertBoolean(base.Hot)
        base.HotRequest = this.$convertBoolean(base.HotRequest)
        base.Kosher = this.$convertBoolean(base.Kosher)
        base.Halal = this.$convertBoolean(base.Halal)
        base.Vegan = this.$convertBoolean(base.Vegan)
        base.Alcoholic = this.$convertBoolean(base.Alcoholic)
        base.VeganRequest = this.$convertBoolean(base.VeganRequest)
        base.DairyFree = this.$convertBoolean(base.DairyFree)
        base.Uncooked = this.$convertBoolean(base.Uncooked)
        const priceInfo = {
          Price: this.info[0].price !== '' ? this.info[0].price : -1,
          Price1: this.info[1].price !== '' ? this.info[1].price : -1,
          Price2: this.info[2].price !== '' ? this.info[2].price : -1,
          Price3: this.info[3].price !== '' ? this.info[3].price : -1,
          Price4: this.info[4].price !== '' ? this.info[4].price : -1,

          PriceComment: this.info[0].comment ? this.info[0].comment : '',
          Price1Comment: this.info[1].comment ? this.info[1].comment : '',
          Price2Comment: this.info[2].comment ? this.info[2].comment : '',
          Price3Comment: this.info[3].comment ? this.info[3].comment : '',
          Price4Comment: this.info[4].comment ? this.info[4].comment : '',

          Calories: this.info[0].calorie !== '' ? this.info[0].calorie : -1,
          Calories1: this.info[1].calorie !== '' ? this.info[1].calorie : -1,
          Calories2: this.info[2].calorie !== '' ? this.info[2].calorie : -1,
          Calories3: this.info[3].calorie !== '' ? this.info[3].calorie : -1,
          Calories4: this.info[4].calorie !== '' ? this.info[4].calorie : -1,

          PriceComment_SecondLang:
            this.AllowSecondLang && this.info[0].secondLangComment !== '' ? this.info[0].secondLangComment : '',
          Price1Comment_SecondLang:
            this.AllowSecondLang && this.info[1].secondLangComment !== '' ? this.info[1].secondLangComment : '',
          Price2Comment_SecondLang:
            this.AllowSecondLang && this.info[2].secondLangComment !== '' ? this.info[2].secondLangComment : '',
          Price3Comment_SecondLang:
            this.AllowSecondLang && this.info[3].secondLangComment !== '' ? this.info[3].secondLangComment : '',
          Price4Comment_SecondLang:
            this.AllowSecondLang && this.info[4].secondLangComment !== '' ? this.info[4].secondLangComment : ''
        }
        const model = Object.assign(base, priceInfo)
        model.Modifiers = model.Modifiers.map(item => item.ModifierCategoryID)
        model.SortOrder = [1]
        model.Name_SecondLang = this.AllowSecondLang ? model.Name_SecondLang : ''
        model.ABV = model.Alcoholic && model.ABV ? model.ABV : -1
        if(this.selectedTV === null || this.selectedTV === ""){
          model.ShowOnTV = 0
        }else{
          let foundTV = this.TVrereferences.find(tv => tv.TVname === this.selectedTV)
          model.ShowOnTV = foundTV.TVid
        }
          
        model.MenuBoardTVOrder = 0
        if(model.ReferenceID)
          model.ReferenceID = model.ReferenceID
        else{
          model.ReferenceID = ""
        }
        if (proceed) {
          this.progressing = true
          return this.$api.foodDrink
          .create(model, true)
            .then((res) => {
              const newId = res && res.FoodDrink
              const rewardIds = this.selectedLoyaltyRewards.map(item => item.value)
              const syncPromise = newId
                ? this.syncLoyaltyRewards(newId, this.edibleType, rewardIds, this.initialLoyaltyRewardIds)
                : Promise.resolve()
              return syncPromise.finally(() => {
                this.progressing = false
                this.modal = false
                this.$emit('refresh', this.category)
              })
            })
            .catch(err => {
              this.progressing = false
              if (err.response.data) {
                this.$showError(err.response.data.Message)
              } else {
                this.$showError('error was occured')
              }
            })
        }
      })
    }
  }
  // computed: {
  //     modal: {
  //         get () {
  //             return this.value
  //         },
  //         set (value) {
  //             this.$emit('input', value)
  //         }
  //     }
  // }
}
</script>

<style scoped></style>
